import {HOST_API} from 'src/config-global';

const RATING_GET_API_URI = '/api/rating/get';

export async function getRating(recipeId) {
  if (!localStorage.getItem('accessToken')) {
    return null;
  }

  const response = await fetch(`${HOST_API}${RATING_GET_API_URI}/${recipeId}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
    }
  });

  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }

    let message = `${response.status}:${response.statusText}`;
    if (response.status < 500) {
      const responseData = await response.json();
      message = responseData.error;
    }

    throw new Error(message);
  }

  return response.json();
}

